/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-template.reducer';

export const TreatmentTemplateDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentTemplateEntity = useAppSelector(state => state.treatmentTemplate.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentTemplateDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentTemplate.detail.title">TreatmentTemplate</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplate.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentTemplateEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplate.name">Name</Translate>
            </span>
          </dt>
          <dd>{treatmentTemplateEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplate.description">Description</Translate>
            </span>
          </dt>
          <dd>{treatmentTemplateEntity.description}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplate.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentTemplateEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplate.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentTemplateEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplate.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{treatmentTemplateEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplate.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentTemplateEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplate.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{treatmentTemplateEntity.timestampEntry}</dd>
          <dt>
            <span id="global">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplate.global">Global</Translate>
            </span>
            <UncontrolledTooltip target="global">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplate.help.global" />
            </UncontrolledTooltip>
          </dt>
          <dd>{treatmentTemplateEntity.global ? 'true' : 'false'}</dd>
          <dt>
            <span id="sharedInternally">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplate.sharedInternally">Shared Internally</Translate>
            </span>
            <UncontrolledTooltip target="sharedInternally">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplate.help.sharedInternally" />
            </UncontrolledTooltip>
          </dt>
          <dd>{treatmentTemplateEntity.sharedInternally ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentTemplate.doctor">Doctor</Translate>
          </dt>
          <dd>{treatmentTemplateEntity.doctor ? treatmentTemplateEntity.doctor.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentTemplate.hospital">Hospital</Translate>
          </dt>
          <dd>{treatmentTemplateEntity.hospital ? treatmentTemplateEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-template" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-template/${treatmentTemplateEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentTemplateDetail;
